<template>
  <div class="whole-page">
    <div class="navbar"><NavBar /></div>
    <!-- 这里是整个页面中间的部分 -->
    <div class="main-content" v-if="DisplayStartPage">
      <!-- 这个是上传卡片 -->
      <div class="upload-card" v-if="DisplayUploadCard">
        <div class="upload-title-text">搬砖</div>
        <div class="upload-main-text">
          请上传一个按照商业模拟系统标准描绘的平面图3dm格式的文件在上传后会看到所有图层与物件的显示，请根据当前项目的设定来设定一些重要的属性，如出入口agent的数量以及店铺类型等
        </div>
        <div class="upload-button">
          <a-upload
            name="file"
            :multiple="false"
            action="http://10.0.5.161:9005/upload_3dm_file"
            @change="upload3dmFile"
            :show-upload-list="false"
          >
            <a-button icon="cloud-upload" size="default">上传文件</a-button>
          </a-upload>
        </div>
      </div>
      <!-- 选择是已有项目还是新建项目 -->
      <div class="projcet-type-card" v-if="DisplayProjectOptionCard">
        <div class="upload-title-text">选择已有项目或新建项目</div>
        <div class="upload-main-text">
          如果是更新现有的项目，请选择已有项目名称，如果是新的项目，请选择新增项目
        </div>
        <div class="choosen-botton">
          <a-button icon="menu" size="default" @click="selectExistProject"
            >已有项目</a-button
          >
          <a-button icon="plus" size="default" @click="createNewProject"
            >新建项目</a-button
          >
        </div>
      </div>

      <!-- 选择已有的项目 -->
      <div class="select-exist-card" v-if="DisplayExistProjectCard">
        <div class="upload-title-text">选择已有的项目</div>
        <div class="upload-main-text">
          选择对应的项目名称，并按确认进入下一步
        </div>
        <div>
          <a-select
            style="width: 250px"
            @change="changeExistProject"
            size="small"
          >
            <a-select-option v-for="item in existProjectList" :key="item.index">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
        <a-button size="default" @click="confirmSelectedProject">确认</a-button>
      </div>
      <!-- 新建项目名称 -->
      <div class="select-exist-card" v-if="DisplayCreateProjectCard">
        <div class="upload-title-text">新建项目名称</div>
        <div class="upload-main-text">
          请按照命名规则新建项目
        </div>
        <a-input placeholder="请输入项目名称" v-model="curProjectName" />
        <a-button size="default" @click="confirmNewProject">确认</a-button>
      </div>
    </div>
    <modelView :curProjectName="curProjectName" :cur3dmFile="cur3dmFileName" class="model-view" v-if="displayModelView"/>
    <div class="bottom-content"><BottomContent /></div>
  </div>
</template>

<script>
import NavBar from "../components/NavBar.vue";
import BottomContent from "../components/BottomContent.vue";
import modelView from "@/components/modelView";

// @ is an alias to /src
// axios
import axios from "axios";
import {
    baseServerUrl
} from "@/utils/baseUrl";
axios.defaults.baseURL = baseServerUrl;

export default {
  name: "Home",
  components: {
    NavBar,
    BottomContent,
    modelView
  },
  data() {
    return {
      // url
      getProjectListUrl: "/check_exist_projects",
      crateNewProjectUrl: "/create_new_project",

      // 各组件显示状态
      DisplayUploadCard: true,
      DisplayProjectOptionCard: false,
      DisplayExistProjectCard: false,
      DisplayCreateProjectCard: false,
      DisplayStartPage: false,  // 是否一开始展示起始页面
      displayModelView:true,  // 是否展示模型页面

      // 已有项目列表
      existProjectList: [],

      // 目前项目名称上传的文件名称
      curProjectName: null,
      cur3dmFileName: null
    };
  },
  methods: {
    // 上传处理部分
    upload3dmFile(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        this.$message.success(`${info.file.name} file uploaded successfully`);
        this.cur3dmFileName = info.file.name
        this.DisplayUploadCard = false;
        this.DisplayProjectOptionCard = true;
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
    // 获取已有项目列表
    getExistProjectList() {
      axios.get(this.getProjectListUrl).then(res => {
        this.existProjectList = res.data;
      });
    },
    // 选取项目名称
    changeExistProject(value) {
      this.curProjectName = this.existProjectList[value].name;
      console.log(this.curProjectName);
    },
    //选择已有项目
    confirmSelectedProject(){
      this.DisplayStartPage = false
      this.displayModelView = true
    },
    //创建新的项目
    confirmNewProject() {
      if (this.curProjectName !== null) {
        const projectName = this.curProjectName;
        axios
          .post(this.crateNewProjectUrl, { project_name: projectName })
          .then(res => {
            if (res.data === 0) {
              this.$message.error(`该项目已经存在`);
            } else {
              this.DisplayCreateProjectCard = false;
              this.DisplayStartPage = false
              this.displayModelView = true
            }
          });
      }
    },
    //卡片部分
    selectExistProject() {
      this.DisplayProjectOptionCard = false;
      this.DisplayExistProjectCard = true;
    },

    createNewProject() {
      this.DisplayProjectOptionCard = false;
      this.DisplayCreateProjectCard = true;
    },

  },

  mounted() {

    // this.getExistProjectList();
  }
};
</script>

<style scoped lang="less">
.whole-page {
  width: calc(100vw);
  height: calc(100vh);
  z-index: 0;
  display: flex;
  flex-direction: column;
}
.navbar {
  width: 100%;
  position: absolute;
  z-index: 3;
}
.bottom-content {
  width: 100%;
  position: absolute;
  bottom: 0px;
  z-index: 3;
}
.main-content {
  width: calc(100vw);
  height: calc(100vh);
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  z-index: 1;
}
.upload-card {
  width: 350px;
  height: 350px;
  background: #5227a3;
  border-radius: 26px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 40px;
  padding-right: 40px;
  text-align: center;
  box-shadow: 0px 0px 20px #616161;
}
.upload-title-text {
  color: #ffffff;
  font-size: 16pt;
  font-weight: bold;
}
.upload-main-text {
  color: #ffffff;
  font-size: 10pt;
  font-weight: 350;
}
.projcet-type-card {
  width: 350px;
  height: 220px;
  background: #5227a3;
  border-radius: 26px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 40px;
  padding-right: 40px;
  text-align: center;
  box-shadow: 0px 0px 20px #616161;
}
.choosen-botton {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.select-exist-card {
  width: 350px;
  height: 280px;
  background: #5227a3;
  border-radius: 26px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 40px;
  padding-right: 40px;
  text-align: center;
  box-shadow: 0px 0px 20px #616161;
}
</style>
